import type { QueuedDevHarnessEvent } from "@/dev-harness/types";

import { countRecords, putRecord, runTransaction } from "./db";

function requestToPromise<T>(request: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function queueTelemetryEvent(event: QueuedDevHarnessEvent): Promise<void> {
  await putRecord("telemetryOutbox", event);
}

export async function countQueuedTelemetryEvents(): Promise<number> {
  return countRecords("telemetryOutbox");
}

export async function listQueuedTelemetryEvents(
  limit = 50,
): Promise<QueuedDevHarnessEvent[]> {
  return runTransaction("telemetryOutbox", "readonly", async (store) => {
    const index = store.index("queuedAt");
    return requestToPromise(index.getAll(null, limit));
  });
}

export async function deleteQueuedTelemetryEvents(ids: string[]): Promise<void> {
  if (!ids.length) {
    return;
  }

  await runTransaction("telemetryOutbox", "readwrite", async (store) => {
    await Promise.all(ids.map((id) => requestToPromise(store.delete(id))));
  });
}
